module.exports = __webpack_public_path__ + "4a8d408459b51ce9646191f88a5b2bec.MP3";